import React from "react";
import * as SC from "./DataGrid.style";

export const DataGridRecords = ({
  columns,
  rows,
  handleRowClick = (row) => null,
  visibility = [],
}) => {
  const visibleSize = {
    xs: 12,
    sm: 12,
    md: 12,
  };

  const getMdByField = (field) =>
    columns.find((item) => item.field === field)?.md ?? 0;

  if (visibility.length > 0) {
    visibleSize.md = visibility.reduce(
      (acc, next) => acc + getMdByField(next),
      0
    );
  }

  return (
    <SC.RecordsHolder>
      {
        // @ts-ignore
        rows?.map((row) => (
          <SC.Record
            key={row.id}
            container
            wrap={"wrap"}
            columns={visibleSize}
            onClick={() => handleRowClick(row)}
          >
            {columns.map(
              ({ label, field, renderer, xs, sm, md }) =>
                (visibility.length === 0 || visibility.includes(field)) && (
                  <SC.RecordItem
                    key={`${row.id}-${label}-${field}`}
                    item
                    xs={xs}
                    sm={sm}
                    md={md}
                  >
                    {renderer ? renderer(row) : row[field]}
                  </SC.RecordItem>
                )
            )}
          </SC.Record>
        ))
      }
      {rows?.length === 0 && <SC.NoDataHolder>No data</SC.NoDataHolder>}
    </SC.RecordsHolder>
  );
};
